(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aleko-brand-reels"] && !Shopify.designMode) return;
  try {
    
(function(){
  function instagramUrl(value){
    try{
      var u=new URL(value);
      if(u.protocol!=='https:'||!['instagram.com','www.instagram.com'].includes(u.hostname))return null;
      var bits=u.pathname.split('/').filter(Boolean),index=bits.findIndex(function(part){return part==='reel'||part==='reels'||part==='p'});
      var code=index>=0?bits[index+1]:'';
      if(!code||!/^[A-Za-z0-9_-]+$/.test(code))return null;
      return 'https://www.instagram.com/'+(bits[index]==='p'?'p':'reel')+'/'+code+'/';
    }catch(e){return null}
  }
  function init(root){
    if(root.dataset.avReady)return;root.dataset.avReady='1';
    var track=root.querySelector('.av-track'),nav=root.querySelector('.av-nav'),prev=root.querySelector('[data-av-prev]'),next=root.querySelector('[data-av-next]'),dialog=root.querySelector('dialog'),player=root.querySelector('[data-av-player]'),original=root.querySelector('[data-av-original]'),fallback=root.querySelector('[data-av-fallback]'),opener=null,oldOverflow='';
    function navState(){if(!track)return;var max=track.scrollWidth-track.clientWidth;nav.hidden=max<4;prev.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft>=max-4}
    function step(direction){var card=track.querySelector('.av-card');if(card)track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
    prev.addEventListener('click',function(){step(-1)});next.addEventListener('click',function(){step(1)});track.addEventListener('scroll',navState,{passive:true});
    var observer;if('ResizeObserver' in window){observer=new ResizeObserver(navState);observer.observe(track)}navState();
    function cleanup(){player.querySelectorAll('video').forEach(function(v){v.pause()});player.replaceChildren();document.documentElement.style.overflow=oldOverflow;if(opener&&opener.isConnected)opener.focus()}
    dialog.addEventListener('close',cleanup);root.querySelector('[data-av-close]').addEventListener('click',function(){dialog.close()});
    dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
    root.addEventListener('click',function(e){
      var trigger=e.target.closest('[data-av-play]');if(!trigger||!root.contains(trigger))return;
      if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey||e.button>0)return;
      var template=trigger.closest('.av-card').querySelector('[data-av-template]'),ig=instagramUrl(trigger.dataset.avInstagram);
      if(typeof dialog.showModal!=='function'||(!template&&!ig))return;
      e.preventDefault();opener=trigger;player.replaceChildren();root.querySelector('[data-av-modal-title]').textContent=trigger.dataset.avTitle||'';
      original.parentElement.hidden=!ig;original.removeAttribute('href');if(ig)original.href=ig;fallback.hidden=!ig||!!template;
      if(template){player.appendChild(template.content.cloneNode(true))}else{
        var iframe=document.createElement('iframe');iframe.title=trigger.dataset.avTitle||'Instagram';iframe.allow='autoplay; encrypted-media; fullscreen; picture-in-picture';iframe.allowFullscreen=true;iframe.referrerPolicy='strict-origin-when-cross-origin';iframe.src=ig+'embed/';player.appendChild(iframe);
      }
      oldOverflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden';
      var video=player.querySelector('video');if(video){video.preload='metadata';video.play().catch(function(){})}
    });
    root.avDispose=function(){if(dialog.open)dialog.close();if(observer)observer.disconnect()};
  }
  function start(scope){scope.querySelectorAll('[data-ak-reels]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){start(document)});else start(document);
  document.addEventListener('shopify:section:load',function(e){start(e.target)});
  document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('[data-ak-reels]').forEach(function(root){if(root.avDispose)root.avDispose()})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aleko-store-reviews"]) return;
  try {
    
  if (!customElements.get('aleko-store-reviews')) {
    customElements.define('aleko-store-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
        this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 8);
        this.visibleCount = this.pageSize;
        this.moreButton = this.querySelector('[data-review-more]');
        this.status = this.querySelector('[data-review-status]');
        this.dialog = this.querySelector('dialog');
        this.fullPhoto = this.querySelector('[data-review-full-photo]');
        this.updateCards();
        this.moreButton.addEventListener('click', () => {
          const nextCard = this.cards[this.visibleCount];
          this.visibleCount += this.pageSize;
          this.updateCards();
          const nextTarget = nextCard?.querySelector('[data-review-photo], .aksr-product');
          nextTarget?.focus({ preventScroll: true });
        });
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-review-photo]');
          if (!link || !this.contains(link) || !this.dialog.showModal) return;
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.fullPhoto.src = link.href;
          this.fullPhoto.alt = link.querySelector('img').alt;
          this.querySelector('[data-review-caption]').textContent = this.fullPhoto.alt;
          this.dialog.showModal();
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.fullPhoto.removeAttribute('src'));
        if (window.Shopify?.designMode) {
          this.editorSelect = (event) => {
            const block = event.target.closest('[data-review-card]');
            const index = this.cards.indexOf(block);
            if (index < 0) return;
            this.visibleCount = Math.max(this.visibleCount, index + 1);
            this.updateCards();
          };
          document.addEventListener('shopify:block:select', this.editorSelect);
        }
      }
      disconnectedCallback() {
        if (this.editorSelect) document.removeEventListener('shopify:block:select', this.editorSelect);
      }
      updateCards() {
        this.cards.forEach((card, index) => { card.hidden = index >= this.visibleCount; });
        this.moreButton.hidden = this.visibleCount >= this.cards.length;
        if (this.cards.length > this.pageSize) {
          this.status.textContent = this.status.dataset.statusTemplate.replace('__SHOWN__', Math.min(this.visibleCount, this.cards.length));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
